/* eslint-disable */ import { EnumReflection } from '@salsita-ai/platform-project-sdk/domain';
export const ApplicationVersion = '0.0.0';
export const PublishedData = {
    type: 'object',
    properties: {
        prices: {
            type: 'object',
            additionalProperties: {
                type: 'object',
                properties: {
                    dealerPrice: {
                        type: 'number'
                    },
                    retailPrice: {
                        type: 'number'
                    },
                    packageDepth: {
                        type: 'number'
                    },
                    packageHeight: {
                        type: 'number'
                    },
                    packageWidth: {
                        type: 'number'
                    },
                    packageWeight: {
                        type: 'number'
                    }
                },
                required: [
                    'dealerPrice',
                    'retailPrice',
                    'packageDepth',
                    'packageHeight',
                    'packageWidth',
                    'packageWeight'
                ],
                additionalProperties: false
            }
        },
        presetCategories: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    img: {
                        type: 'string'
                    },
                    imgAlt: {
                        type: 'string'
                    },
                    presets: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                configurationId: {
                                    type: 'string'
                                },
                                revisionId: {
                                    type: 'string'
                                },
                                readToken: {
                                    type: 'string'
                                },
                                name: {
                                    type: 'string'
                                },
                                description: {
                                    type: 'string'
                                },
                                img: {
                                    type: 'string'
                                },
                                imgAlt: {
                                    type: 'string'
                                },
                                detailTitle: {
                                    type: 'string'
                                },
                                detailDescription: {
                                    type: 'string'
                                },
                                tags: {
                                    type: 'array',
                                    items: {
                                        type: 'string'
                                    }
                                }
                            },
                            required: [
                                'configurationId',
                                'revisionId',
                                'readToken',
                                'name',
                                'description'
                            ],
                            additionalProperties: false
                        }
                    }
                },
                required: [
                    'id',
                    'name',
                    'presets'
                ],
                additionalProperties: false
            }
        },
        recipes: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    collection: {
                        type: 'string'
                    },
                    configuration: {
                        type: 'object',
                        properties: {
                            modelVersion: {
                                type: 'number'
                            },
                            entities: {
                                type: 'array',
                                items: {
                                    type: 'object',
                                    properties: {
                                        id: {
                                            type: 'string'
                                        },
                                        type: {
                                            type: 'string'
                                        }
                                    },
                                    required: [
                                        'id',
                                        'type'
                                    ],
                                    additionalProperties: true
                                }
                            },
                            rootEntityType: {
                                type: 'string'
                            },
                            recipeIds: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            }
                        },
                        required: [
                            'modelVersion',
                            'entities',
                            'rootEntityType',
                            'recipeIds'
                        ],
                        additionalProperties: false
                    }
                },
                required: [
                    'id',
                    'name',
                    'description',
                    'collection',
                    'configuration'
                ],
                additionalProperties: false
            }
        }
    },
    required: [],
    additionalProperties: false
};
export const SessionData = {
    type: 'object',
    properties: {
        emailAddress: {
            type: 'string'
        },
        tags: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required: [
        'tags'
    ]
};
export const FrontendData = {};
export const FinalizeData = {
    type: 'object',
    properties: {
        firstName: {
            type: 'string'
        },
        lastName: {
            type: 'string'
        },
        dealerEmailAddresses: {
            type: 'string'
        },
        customerEmailAddresses: {
            type: 'string'
        },
        companyName: {
            type: 'string'
        },
        projectName: {
            type: 'string'
        },
        shippingAddressStreet: {
            type: 'string'
        },
        shippingAddressCity: {
            type: 'string'
        },
        shippingAddressState: {
            type: 'string'
        },
        shippingAddressZipCode: {
            type: 'string'
        },
        shippingAddressCountryCode: {
            type: 'string'
        }
    },
    required: [
        'firstName',
        'lastName',
        'dealerEmailAddresses',
        'customerEmailAddresses',
        'companyName',
        'projectName',
        'shippingAddressStreet',
        'shippingAddressCity',
        'shippingAddressState',
        'shippingAddressZipCode',
        'shippingAddressCountryCode'
    ],
    additionalProperties: false
};
export const PrefetchedFinalizeData = {
    type: 'object',
    properties: {
        shippingPrice: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ]
        },
        errorMessage: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'shippingPrice',
        'errorMessage'
    ],
    additionalProperties: false
};
export const FinalizeResult = {
    type: 'object',
    properties: {
        pdfLink: {
            type: 'string'
        },
        imageWallA: {
            type: 'string'
        },
        imageWallB: {
            type: 'string'
        },
        imageWallC: {
            type: 'string'
        },
        finalizationErrorMessage: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'pdfLink',
        'imageWallA',
        'imageWallB',
        'imageWallC',
        'finalizationErrorMessage'
    ],
    additionalProperties: false
};
export const CallbackData = {
    type: 'object',
    properties: {
        finalizationErrorMessage: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    required: [
        'finalizationErrorMessage'
    ],
    additionalProperties: false
};
export const BackendData = undefined;
export const NavigationState = new EnumReflection('NavigationState', {
    enum: [
        'Room',
        'RoomContent',
        'Recipes',
        'Summary',
        'FinalizeGlamour',
        'Finalize'
    ]
});
export const ViewState = new EnumReflection('ViewState', {
    enum: [
        'Default'
    ]
});
export const ToolState = new EnumReflection('ToolState', {
    enum: [
        'Default'
    ]
});
export const AdminNavigationState = new EnumReflection('AdminNavigationState', {
    enum: [
        'Products'
    ]
});
export const AdminViewState = new EnumReflection('AdminViewState', {
    enum: [
        'Default'
    ]
});

//# sourceMappingURL=application-types.js.map